import session from './session'
import format from 'string-format'
import {empty_run} from '../store/defaults'
/*const config = {
  headers: {'Content-Type': 'application/json'},
  withCredentials: true,
  // baseURL: 'http://192.168.86.49:8000/PgmTools/rest/v2' //Backend server
};*/

export default {
	/**
	 * Получить из REST текущие планируемые запуски,
	 * чтобы пользователь мог планировать (добавлять) в них библиотеки.
	 * @returns {AxiosPromise<any>}
	 */

	updateTimeStamp(time_stamp, run_id) {
		return session.post(format('/ngs_run/{0}/update_time_stamp/', run_id), {time_stamp: time_stamp})
	},

	editRun(run_id, data) {
		return session.patch(format('/ngs_run/{0}/', run_id), data)
	},

	equalizeRun(run_id, data) {
		return session.post(format('/ngs_run/{0}/equalize_run/', run_id), data)
	},

	getRun(run_id) {
		if (run_id) {
			return session.get(format('/ngs_run/{0}/', run_id))
		} else {
			let response = {}
			response['data'] = empty_run
			return Promise.resolve(response)
		}
	},

	getRuns(query_list) {
		/**
		 * @param {array} query_list параметры для фильтров,
		 *  а так же page и page_size, если нужна постраничность
		 */
		let query = ""

		if (query_list.length) {
			query = "?" + query_list.join("&")
		}
		return session.get(format('/ngs_run/{0}', query))
	},

	acquireBarcodes(run_id, explib_ids, barcode_box_id) {
		return session.post(format('ngs_run/{0}/acquire_barcodes/', run_id), {
			explib_ids: explib_ids,
			barcode_box: barcode_box_id
		})
	},

	get_time_stamp(run_id) {
		return session.get(format('ngs_run/{0}/get_time_stamp/', run_id))
	},

	/**
	 *
	 * @param attrs:
	 * {
	 *      date: null,
          chip_names: [''],
          run_name: year + '-',
          barcode_set: 'IonXpress',
          chip_type: 'S5-540',
          chip_num: null,
          ngs_source: 'S5',
          linked_runs: [],
        }
	 * @returns {*}
	 */

	create_run(attrs) {
		return session.post('/ngs_run/create_run/', attrs)
	},
}